(function () {
  'use strict';

  if (window.innerWidth < 768) {
    var btn = document.getElementById('cure-form-sbmt-btn');
    btn?.classList.remove('omr-button-primary-large');
    btn?.classList.add('omr-button-primary-medium');
  }

  // form modification
  var cureSection = document.getElementById('cure-form-section');
  var cureFormContactformbox = cureSection.querySelector('.contactformbox');
  var cureFormBtn = document.getElementById('omr-button_qcgForm');

  cureFormContactformbox.style.display = 'none';

  if (cureFormBtn) {
    cureFormBtn.classList.add('omr-button-primary-large');
    cureFormBtn.classList.add('omr-button-primary--purple');
    cureFormBtn.style.width = 'unset';
  }
})();
